import { ComplexValue } from 'ui/common/types';
import { ValidationMessage } from 'ui/common/validation/types';

export const mergeOptions = (options: ComplexValue<number>[] = [], valueItems: ComplexValue<number>[]) => {

  if (!valueItems || valueItems.length === 0 || valueItems === options) {
    return options;
  }

  const additionalOptions = valueItems.filter(i => !options.some(o => o.value === i.value));

  return additionalOptions.length === 0
    ? options
    : [
      ...options,
      ...additionalOptions
    ];
};

export const getUniqueMessages = (messages: ValidationMessage[]) =>
  messages && messages.reduce((result, message) => {

    return result.some(r => r.message === message.message)
      ? result
      : [...result, message];
  }, [] as ValidationMessage[]) || [];
